import axios from "../../plugins/PermissionamentoInterceptor";

export const actions = {
    getPermissoes(context, token) {
        return new Promise((resolve, reject) => {
            axios.get('/')
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/permissoes.js